import { render } from "./summaryTabOrderTradeIn.vue?vue&type=template&id=194df3f6&ts=true"
import script from "./summaryTabOrderTradeIn.vue?vue&type=script&lang=ts"
export * from "./summaryTabOrderTradeIn.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__